import notice from './src/notice.vue'

export default notice
